import { DefineComponent, FunctionalComponent } from "vue";
import { VueDashboardItemClasses } from "../skyVue/dashboardItem/classes";

type DragHandleProps =
    {
        color?: string;
    };

const DragHandle: FunctionalComponent<DragHandleProps> = function vDragHandle(props: DragHandleProps, _context)
{
    const dragHandleBackgroundImage = 
        `radial-gradient(circle at 0.3rem 0.5rem, ${props.color} 0.15rem, transparent 0),` +
        `radial-gradient(circle at 0.7rem 0.5rem, ${props.color} 0.15rem, transparent 0),` +
        `radial-gradient(circle at 0.3rem 0.9rem, ${props.color} 0.15rem, transparent 0),` +
        `radial-gradient(circle at 0.7rem 0.9rem, ${props.color} 0.15rem, transparent 0),` +
        `radial-gradient(circle at 0.3rem 1.3rem, ${props.color} 0.15rem, transparent 0),` +
        `radial-gradient(circle at 0.7rem 1.3rem, ${props.color} 0.15rem, transparent 0),` +
        `radial-gradient(circle at 0.3rem 1.7rem, ${props.color} 0.15rem, transparent 0),` +
        `radial-gradient(circle at 0.7rem 1.7rem, ${props.color} 0.15rem, transparent 0)`;

    return (
        <div
            aria-label="Drag Handle"
            aria-describedby="VueDashboardItem__dragHandleDesc"
            class={VueDashboardItemClasses.DragHandle}
            tabindex="0"
            onMousedown={(evt) => (evt?.target as HTMLElement).focus()}
            style={{ backgroundImage: dragHandleBackgroundImage, cursor: "grab" }} />
    );
};

DragHandle.props = ["color"];
export default DragHandle as unknown as DefineComponent<DragHandleProps, JSX.Element>;
